import BackedEnum from '@/enums/BackedEnum';

export default class PetSpecies extends BackedEnum {
  static values() {
    return BackedEnum.values.call(this)
      .filter((value) => value !== PetSpecies.SmallMammal);
  }
}

PetSpecies.Dog = 'DOG';
PetSpecies.Cat = 'CAT';
PetSpecies.Horse = 'HORSE';
PetSpecies.Bird = 'BIRD';
PetSpecies.Rabbit = 'RABBIT';
PetSpecies.Reptile = 'REPTILE';
PetSpecies.Amphibian = 'AMPHIBIAN';
PetSpecies.Spider = 'SPIDER';
PetSpecies.Fish = 'FISH';
PetSpecies.FarmAnimal = 'FARM_ANIMAL';
PetSpecies.SmallMammal = 'SMALL_MAMMAL';
PetSpecies.Other = 'OTHER';

PetSpecies.getIcon = (species) => {
  switch (species) {
    case PetSpecies.Dog:
    case PetSpecies.Cat:
    case PetSpecies.Rabbit:
    case PetSpecies.Spider:
    case PetSpecies.Fish:
    case PetSpecies.Horse:
      return ['fal', species.toLowerCase()];
    case PetSpecies.Amphibian:
      return ['fal', 'turtle'];
    case PetSpecies.Bird:
      return ['fal', 'crow'];
    case PetSpecies.Reptile:
      return ['fal', 'snake'];
    case PetSpecies.FarmAnimal:
      return ['fal', 'sheep'];
    case PetSpecies.SmallMammal:
      return ['fal', 'rabbit'];
    case PetSpecies.Other:
    default:
      return ['fal', 'paw'];
  }
};
